import fetch from '../auth/FetchInterceptor';
import useSWR from 'swr';

export default function useDocPage(pageId) {
  const { data, error, isLoading } = useSWR(
    `/documentation/page/${pageId}`,
    fetch,
    {
      refreshInterval: 0,
    }
  );

  return {
    page: data?.data,
    isLoading,
    isError: error,
  };
}
